export const EDIT = 'edit'
export const CREATE = 'create'
export const SELF_EDIT = 'self-edit'